<template>
    <v-overlay
        :model-value="loading"
        persistent
        class="align-center justify-center"
    >
        <v-progress-circular color="blue-lighten-3" indeterminate :size="120">
            <v-img
                src="/images/d3_connect.png"
                :size="10"
                class="loading-spinner"
                :style="{
                    marginLeft: '9px',
                }"
                indeterminate
            ></v-img>
        </v-progress-circular>
    </v-overlay>

    <v-card class="pa-4">
        <v-row>
            <v-col cols="12" md="6">
                <v-card color="blue-grey-lighten-5">
                    <v-card-title>
                        <v-icon
                            icon="mdi:mdi-circle"
                            :size="24"
                            :color="color"
                        />
                        Tank Level
                    </v-card-title>
                    <v-card-text>
                        <div id="chart"></div>
                        <div
                            v-if="error"
                            class="message text-h6"
                            style="color: red"
                        >
                            {{ error }}
                        </div>
                        <div v-if="loading" class="message text-h6">
                            Fetching Data
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" md="6">
                <v-card color="blue-grey-lighten-5">
                    <v-card-title> Distributor </v-card-title>
                    <v-card-text>
                        <div style="min-height: 365px">
                            <v-img
                                src="https://petrometer.myilevel.com/images/PetrometerSmallLogo.png"
                                :width="120"
                                rounded
                                class="mb-4"
                            />

                            <div class="mb-4">
                                <b>Petro-meter</b> <br />
                                300 W. Hoffman Ave. Lindenhurst, NY 11757
                            </div>
                            <div class="mb-4">
                                <b>Phone</b> <br />
                                631-225-2322
                            </div>
                            <div>
                                <b>Emergency phone</b> <br />
                                631-225-2322
                            </div>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12">
                <v-card color="blue-grey-lighten-5">
                    <div id="chart2"></div>
                    <div
                        v-if="error"
                        class="message text-h6"
                        style="color: red"
                    >
                        {{ error }}
                    </div>
                    <div v-if="loading" class="message text-h6">
                        Fetching Data
                    </div>
                </v-card>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
import axios from "axios";
import moment from "moment";
import ApexCharts from "apexcharts";

export default {
    name: "FacilitiesOilUse",
    components: {},
    data() {
        return {
            loading: false,
            data: null,
            chart: null,
            chart2: null,
            error: null,
        };
    },
    computed: {
        color() {
            if (this.data && typeof this.data === "object") {
                let capacity = this.data.tank.capacity;
                let level = this.data.tank.gallons;
                if (level > capacity / 4) {
                    return "#4CAF50";
                }
            }

            return "#F44336";
        },
    },
    mounted() {
        this.fetchOilMeter();
    },
    beforeUnmount() {
        if (this.chart) {
            this.chart.destroy();
        }
        if (this.chart2) {
            this.chart2.destroy();
        }
    },
    methods: {
        fetchOilMeter() {
            this.error = "Error fetching data";
            alert(
                "Oil meter data is no longer available.\nCheck back later for updates."
            );
            // this.loading = true;
            //
            // let request = axios.create({
            //     params: {
            //         //
            //     },
            // });
            // request
            //     .get(route("api.getOilMeter"))
            //     .then((res) => {
            //         if (res.data.data && typeof res.data.data === "object") {
            //             this.data = res.data.data;
            //             this.showLevel();
            //             this.showHistory();
            //         } else {
            //             this.error = "Error fetching data";
            //         }
            //     })
            //     .catch((error) => {
            //         console.error("Error fetching oil meter:", error);
            //         this.error = "Error fetching data";
            //         this.loading = false;
            //     })
            //     .finally(() => {
            //         this.loading = false;
            //     });
        },
        showLevel() {
            var capacity = Math.round(this.data.tank.capacity);
            var level = Math.round(this.data.tank.gallons);
            var description = this.decodeHtml(this.data.tank.description);

            var options = {
                series: [
                    {
                        name: "Gallons",
                        data: [level],
                        color: this.color,
                    },
                ],
                chart: {
                    type: "bar",
                    height: 350,
                },
                title: {
                    text: description,
                    align: "left",
                    margin: 10,
                    offsetX: 0,
                    offsetY: 0,
                    floating: false,
                    style: {
                        fontSize: "18px",
                        fontWeight: "bold",
                        color: "#448AFF",
                    },
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: "25%",
                        endingShape: "rounded",
                    },
                },
                dataLabels: {
                    enabled: false,
                },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ["transparent"],
                },
                xaxis: {
                    title: {
                        text: `Fill Capacity ${this.data.tank.capacity} gal\n ${this.data.tank.spgDescription}`,
                        style: {
                            fontSize: "14px",
                            fontWeight: "bold",
                            color: "#448AFF",
                        },
                    },
                    categories: [
                        `${Math.round(
                            this.data.tank.gallons
                        )} gal (${Math.round(this.data.tank.inches)}")`,
                    ],
                    labels: {
                        style: {
                            fontSize: "16px",
                            fontWeight: "bold",
                        },
                    },
                },
                yaxis: {
                    max: capacity,
                    tickAmount: 4,
                    labels: {
                        formatter: function (val) {
                            val = Math.round(val);
                            if (val === capacity) return "Full";
                            if (val === Math.round(capacity * 0.75))
                                return "3/4";
                            if (val === Math.round(capacity * 0.5))
                                return "1/2";
                            if (val === Math.round(capacity * 0.25))
                                return "1/4";
                            if (val === 0) return "Empty";
                        },
                        style: {
                            fontSize: "12px",
                            fontWeight: "bold",
                        },
                    },
                },
                fill: {
                    opacity: 1,
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return val;
                        },
                    },
                },
            };

            var chart = new ApexCharts(
                document.querySelector("#chart"),
                options
            );
            this.chart = chart;
            this.chart.render();
        },
        showHistory() {
            var capacity = Math.round(this.data.tank.capacity);

            var values = [];
            var labels = [];

            this.data.tankLevels.forEach((item) => {
                values.push(Math.round(item.gallons));
                labels.push(moment(item.reportedDate).format("M/D/YY"));
            });

            var options = {
                series: [
                    {
                        name: "Gallons",
                        data: values,
                    },
                ],
                chart: {
                    height: 350,
                    type: "line",
                    zoom: {
                        enabled: false,
                    },
                },
                title: {
                    text: "Tank Level - Last 30 Days",
                    align: "middle",
                    margin: 10,
                    offsetX: 0,
                    offsetY: 0,
                    floating: false,
                    style: {
                        fontSize: "18px",
                        fontWeight: "bold",
                        color: "#448AFF",
                    },
                },
                dataLabels: {
                    enabled: false,
                },
                stroke: {
                    curve: "straight",
                },
                grid: {
                    row: {
                        colors: ["#f3f3f3", "transparent"],
                        opacity: 0.5,
                    },
                },
                xaxis: {
                    categories: labels,
                },
                yaxis: {
                    max: capacity,
                    min: 0,
                    tickAmount: 4,
                },
            };

            var chart = new ApexCharts(
                document.querySelector("#chart2"),
                options
            );
            this.chart2 = chart;
            this.chart2.render();
        },
        decodeHtml(str) {
            var txt = document.createElement("textarea");
            txt.innerHTML = str;
            return txt.value;
        },
    },
};
</script>

<style scoped>
.message {
    min-height: 365px;
    align-content: center;
    text-align: center;
}
</style>
